import React from 'react';
import { withRouter } from 'react-router-dom';
import {
    Card,
    CardContent,
    CardActions,
    Typography,
    makeStyles,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from '@material-ui/core';
import { CallMadeRounded as SetaIcon } from '@material-ui/icons'
import { MenuEnum, StatusPedidoEnum } from '../enums';
import IconeStatusPedido from './IconeStatusPedido';

const useStyles = makeStyles(theme => ({
    card: {
        [theme.breakpoints.up('sm')]: {
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: theme.palette.action.hover
            }
        }
    },
    icone: {
        float: 'right'
    },
    listItemIcon: {
        minWidth: 25
    },
    gutters: {
        paddingLeft: 6
    },
    iconeStatusPedido: {
        color: theme.palette.primary[200]
    },
    placa: {
        color: theme.palette.text.disabled
    },
    status: {
        color: theme.palette.text.disabled
    },
    modelo: {
        color: theme.palette.text.secondary,
        minHeight: 60,
        marginTop: theme.spacing(2)
    }
}));

function CardPedido(
    {
        pedido,
        history
    }
) {
    const classes = useStyles();

    const handleClickDetalhePedido = (objPedido) => {
        const {
            contrato,
            pedidoContrato,
            item,
            sequencia,
            codigoStatus,
            usuarioVeiculo
        } = objPedido;

        // if (codigoStatus === StatusPedidoEnum.UTILIZACAO)
        //     history.push(`${MenuEnum.properties[MenuEnum.SERVICOS].path}/${usuarioVeiculo.placa}`);
        // else
        history.push(`${MenuEnum.properties[MenuEnum.MEUS_CARROS].path}/${contrato}/${pedidoContrato}/${item}/${sequencia}`);
    }

    return (
        <Card className={classes.card}
            onClick={() => handleClickDetalhePedido(pedido)}>
            <CardContent>
                <SetaIcon className={classes.icone}
                    color='primary' />
                <Typography variant='h5'
                    color='primary'>
                    {pedido.usuarioVeiculo.usuario}
                </Typography>
                <Typography variant='caption'
                    className={classes.placa}>
                    {pedido.usuarioVeiculo.placa}
                </Typography>
                <Typography variant="body2"
                    className={classes.modelo}>
                    {pedido.usuarioVeiculo.modelo}
                </Typography>
            </CardContent>
            <CardActions>
                <List>
                    <ListItem classes={{ gutters: classes.gutters }}>
                        <ListItemIcon classes={{ root: classes.listItemIcon }}>
                            <IconeStatusPedido codigoStatus={pedido.codigoStatus}
                                fontSize='small'
                                className={classes.iconeStatusPedido} />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant='caption'
                                className={classes.status}>
                                {pedido.descricaoStatus}
                            </Typography>
                        </ListItemText>
                    </ListItem>
                </List>
            </CardActions>
        </Card>
    );
}

export default withRouter(CardPedido);